<script setup>
    import {ref} from "vue";
    import SubNav from "../../components/global/SubNav.vue";
    import {useRoute} from "vue-router";

    const route = useRoute()

    const links = ref([
        { to: '/tickets/open', label: 'Open'},
        { to: '/tickets/complete', label: 'Completed'},
        { to: '/tickets/stats', label: 'Stats'},
    ]);

</script>

<template>
    <sub-nav :links="links" v-if="route.name !== 'tickets-single'" />
    <router-view v-slot="{ Component }">
        <keep-alive :include="['TicketsOpenView', 'TicketsCompletedView']">
            <component :is="Component" />
        </keep-alive>
    </router-view>
</template>
